import { Injectable } from '@angular/core';
import { DefaultUrlSerializer, UrlTree } from '@angular/router';

/**
 * Lowercases everything before the first # or ?
 */
@Injectable()
export class LowerCaseUrlSerializer extends DefaultUrlSerializer {
    parse(url: string): UrlTree {
        const indexOfQuery = url.indexOf('?');
        const indexOfAnchor = url.indexOf('#');
        if (indexOfQuery !== -1 || indexOfAnchor !== -1) {
            const firstSymbolIndex = Math.min(
                indexOfQuery !== -1 ? indexOfQuery : 99999,
                indexOfAnchor !== -1 ? indexOfAnchor : 99999
            );
            return super.parse(
                url.substring(0, firstSymbolIndex).toLocaleLowerCase().concat(url.substring(firstSymbolIndex))
            );
        }
        return super.parse(url.toLocaleLowerCase());
    }
}
